export const text = {
    "English" : {
        COPYRIGHT:"Copyright © 2021 DPR Construction.All Rights Reserved.",
        PRIVACY_POLICY:"Privacy Policy"
    },
    "Español" : {
        COPYRIGHT:"Copyright © 2021 DPR Construction. Todos los derechos reservados.",
        PRIVACY_POLICY:"Política de privacidad"
    }
} 